"use client";

import { motion } from "framer-motion";
import { useMotion } from "@/contexts/MotionContext";
import { useRouter, useSearchParams } from "next/navigation";
import { SERVICE_BUCKETS } from "@/lib/config/services.config";

const workCategories = [
  { id: "all", label: "All Work" },
  ...SERVICE_BUCKETS.map((bucket) => ({
    id: bucket.slideCategory,
    label: bucket.title,
  })),
];

interface WorkFiltersProps {
  activeCategory: string;
  onCategoryChange: (category: string) => void;
}

export default function WorkFilters({
  activeCategory,
  onCategoryChange,
}: WorkFiltersProps) {
  const { isMotionEnabled } = useMotion();
  const router = useRouter();
  const searchParams = useSearchParams();

  const handleCategoryChange = (categoryId: string) => {
    onCategoryChange(categoryId);

    // Update URL
    const params = new URLSearchParams(searchParams.toString());
    if (categoryId === "all") {
      params.delete("category");
    } else {
      params.set("category", categoryId);
    }

    const newUrl = params.toString() ? `/work?${params.toString()}` : "/work";
    router.push(newUrl);
  };

  return (
    <div className="flex flex-wrap gap-2 md:gap-4">
      {workCategories.map((category) => (
        <motion.button
          key={category.id}
          onClick={() => handleCategoryChange(category.id)}
          className={`px-4 py-2 rounded-full text-sm md:text-base font-medium transition-all duration-300 ${
            activeCategory === category.id
              ? "bg-black dark:bg-white text-white dark:text-black"
              : "bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700"
          }`}
          whileHover={isMotionEnabled ? { scale: 1.05 } : {}}
          whileTap={isMotionEnabled ? { scale: 0.95 } : {}}
          transition={{ duration: 0.2 }}
        >
          {category.label}
        </motion.button>
      ))}
    </div>
  );
}
